import ClassNames from "classnames";
import * as React from "react";

import Styles from "./Tabs.module.css";

import Button from "../Button";

export interface Props {
  className?: string;
  items?: any;
  small?: boolean;
  fullWidth?: boolean;
  position?: "horizontal";
  wrapperClass?: string;
}

const Tabs: React.FC<Props> = props => {
  const {
    className,
    items,
    position = "horizontal",
    small,
    fullWidth,
    wrapperClass
  } = props;

  const [activeTab, setActiveTab] = React.useState("");

  const isActive = id => {
    return activeTab === id;
  };

  const activeNow = e => {
    setActiveTab(e.target.id);
  };

  return (
    <div
      className={ClassNames({
        [wrapperClass]: wrapperClass,
        [Styles.tabWrapper]: true
      })}
    >
      <div
        className={ClassNames({
          [className]: className,
          [Styles.fullWidth]: fullWidth,
          [Styles[position]]: true
        })}
      >
        {items.map((item, i) => (
          <Button
            className={ClassNames({
              [Styles.small]: small,
              [Styles.fullWidth]: fullWidth,
              [Styles.active]: isActive(item.id)
            })}
            variant="text"
            onBlur={activeNow}
            key={i}
            {...item}
          />
        ))}
      </div>
    </div>
  );
};

export default Tabs;
